import { render } from "./RobotInfo.vue?vue&type=template&id=46da725f&scoped=true"
import script from "./RobotInfo.vue?vue&type=script&lang=js"
export * from "./RobotInfo.vue?vue&type=script&lang=js"

import "./RobotInfo.vue?vue&type=style&index=0&id=46da725f&lang=scss"
import "./RobotInfo.vue?vue&type=style&index=1&id=46da725f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46da725f"

export default script